// const AE = 'https://static.rfstat.com/renderforest/images/website_maker_images/ae.svg'

const imgPath =
  'https://static.rfstat.com/renderforest/images/website_maker_images/'

export const LANGUAGES = [
  {
    iconUrl: `${imgPath}gb.svg`,
    langCode: 'en',
    text: 'English',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}br.svg`,
    langCode: 'pt',
    text: 'Português',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}es.svg`,
    langCode: 'es',
    text: 'Español',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}de.svg`,
    langCode: 'de',
    text: 'Deutsch',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}fr.svg`,
    langCode: 'fr',
    text: 'Français',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}jp.svg`,
    langCode: 'jp',
    text: '日本語',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}tr.svg`,
    langCode: 'tr',
    text: 'Türkçe',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}ru.svg`,
    langCode: 'ru',
    text: 'Русский',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}it.svg`,
    langCode: 'it',
    text: 'Italiano',
    status: 'public'
  },
  {
    iconUrl: `${imgPath}ko.svg`,
    langCode: 'ko',
    text: '한국어',
    status: 'unpublic'
  }
]
